module.exports = __webpack_public_path__ + "img/garage_burger_2.a710f0f6.jpeg";